/* eslint-disable @typescript-eslint/naming-convention */
import { CurrencyInfo } from '@api/types';

export const currencies: Record<string, CurrencyInfo> = {
  EUR: {
    symbol: '€',
    name: 'EURO',
    fraction: 2,
  },
  USD: {
    symbol: '$',
    name: 'US Dollar',
    fraction: 2,
  },
  JPY: {
    symbol: '¥',
    name: 'Japanese Yen',
    fraction: 0,
  },
  BRL: {
    symbol: 'R$',
    name: 'Brazilian Real',
    fraction: 2,
  },
  GBP: {
    symbol: '£',
    name: 'Pound sterling',
    fraction: 2,
  },
  KRW: {
    symbol: '₩',
    name: 'South Korean Won',
    fraction: 0,
  },
};
